import { Config, State } from "../types"
import { tryLoadStateFromLocalStorage } from "./local_storage"
import { blankFrequencyState } from "./reducer"

const BASE_STATE: Omit<State, "designations"> = {
  focusedPane: "left",
  frequency: { type: "once" },
  errors: {},
  savePaymentMethodChecked: true,
  feeCovered: false,
  validateOnBlur: false,
}

type ConfigForInitializeState = Pick<
  Config,
  "default_schedule" | "default_schedules" | "default_amount"
> & {
  default_fund: Pick<Config["default_fund"], "id">
}

export function initializeState(config: ConfigForInitializeState): State {
  const amount = config.default_amount || ""
  const defaultState = {
    ...BASE_STATE,
    designations: [{ fundId: config.default_fund.id, amount }],
  }

  if (config.default_schedule?.weekly) {
    defaultState.frequency = blankFrequencyState(
      "weekly",
      config.default_schedules,
    )
  }

  return tryLoadStateFromLocalStorage() || defaultState
}
